import React, { useEffect, useState } from "react";
import styles from "./eventDetails.module.css";
import EventDetailsHeader from "components/Event/Header";
import EventTab from "components/Event/EventTab";
// import RepsTab from "components/Reps";
// import Analytics from "components/Setting/Analytics";
import Status from "components/Setting/Status";
import { useNavigate, useParams } from "react-router-dom";
import { getData } from "utils/queries";
import PopUpModal from "common/Popup";
import ShareEventPreview from "components/Event/SharePreview";
import Tabs_ from "common/Tabs";

const EventDetails = () => {
  const Badges = ["Draft", "Not announced"];

  const navigate = useNavigate();

  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  
  const [data, setData] = useState();

  const { event_id } = useParams();

  const fetchData = async (event_id) => {
    try {
      const result = await getData(`event/events/${event_id}`);
      if (result?.data?.data) {
        setData(result?.data?.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    if (event_id) {
      fetchData(event_id);
    }
  }, [event_id]);


  
  

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const Functionalities = [
    // {
    //   label: "Share",
    //   onClick: () => {
    //     setModalIsOpen(true);
    //   },
    // },
    {
      label: "Preview",
      onClick: () => {
        navigate(`/event/event-preview/${event_id}`);
      },
    },
    // { label: "Duplicate", onClick: () => {} },
    {
      label: "Edit Event",
      onClick: () => {
        return navigate(`/event/edit-event/${event_id}`);
      },
    },
  ];


  return (
    <div className={styles.eventDetails}>
      <div className={styles.BackButton} onClick={() => navigate("/event")}>
        <img src="/icons/backArrow.svg" alt="black  arrow" />
        Back
      </div>
      <div className={styles.container}>
        <EventDetailsHeader
          Badges={Badges}
          data={data?.events}
          Functionalities={Functionalities}
        />

        {/* <Tabs_
          TabList_={[
            { label: "Event" },
            // { label: "Rep's" },
            // { label: "Analytics" },
            { label: "Status" },
          ]}
          TabContent_={[
            { content: <EventTab /> },
            // { content: <RepsTab /> },
            // { content: <Analytics /> },
            { content: <Status event_id={event_id} /> },
          ]}
          selectedIndex={selectedTabIndex}
          setSelectedIndex={(e) => setSelectedTabIndex(e)}
        /> */}
      </div>
      <PopUpModal modalIsOpen={modalIsOpen}>
        <ShareEventPreview setModalIsOpen={setModalIsOpen} />
      </PopUpModal>
    </div>
  );
};

export default EventDetails;
